import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=6ee32f9f&scoped=true&"
var script = {}
import style0 from "./goods.vue?vue&type=style&index=0&id=6ee32f9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee32f9f",
  null
  
)

export default component.exports